import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isAdminGlobale } from '../../lib/ruoli';
import { useEntityList, SectionHead, statoLista, BoolPill, OpenLink } from './common';
import Condominio from './condominio';

/**
 * Configurazione del condominio.
 *
 * L'amministratore di condominio ne ha uno solo: gli si apre direttamente la
 * sua pagina, senza un elenco da attraversare. L'amministratore globale li
 * vede tutti e ne crea di nuovi.
 */
export default function Impostazioni({ userInfo }) {
    const globale = isAdminGlobale(userInfo);
    const { items, loading, error, reload } = useEntityList('user_group', 'name', 'asc');

    if (!globale) {
        const idGruppo = parseInt(userInfo && userInfo.idUserGroup, 10) || 0;
        return <Condominio idGruppo={idGruppo || null} senzaElenco />;
    }

    const stato = statoLista({
        loading: loading,
        error: error,
        empty: items.length === 0,
        icon: 'building-user',
        message: 'Nessun condominio: creane uno per iniziare.',
        onRetry: reload
    });

    return (
        <section className="lv-card lv-card-pad">
            <SectionHead
                eyebrow="Condomini"
                title="Condomini"
                subtitle="Ogni condominio ha le proprie sale, anagrafiche e utenti."
                action={
                    <Link to="/admin/impostazioni/nuovo" className="lv-btn lv-btn-primary lv-btn-pill">
                        <FontAwesomeIcon icon={['fas', 'plus']} />
                        Nuovo condominio
                    </Link>
                }
            />

            {stato || (
                <div className="lv-table-wrap">
                    <table className="lv-table">
                        <thead>
                            <tr>
                                <th>Condominio</th>
                                <th>Dove</th>
                                <th>Referente</th>
                                <th>Stato</th>
                                <th>Azioni</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map(g => (
                                <tr key={g.id}>
                                    <td data-label="Condominio">
                                        <div className="lv-cell-strong">{g.name}</div>
                                        {g.indirizzo && <div className="lv-cell-sub">{g.indirizzo}</div>}
                                    </td>
                                    <td data-label="Dove">
                                        {[g.citta, g.cap].filter(Boolean).join(' · ') || '—'}
                                    </td>
                                    <td data-label="Referente">
                                        <div className="lv-cell-strong">{g.referente || '—'}</div>
                                        {g.email_referente && (
                                            <div className="lv-cell-sub">{g.email_referente}</div>
                                        )}
                                    </td>
                                    <td data-label="Stato">
                                        <BoolPill value={g.attivo} labelOn="Attivo" labelOff="Sospeso" />
                                    </td>
                                    <td data-label="Azioni">
                                        <div className="lv-row-actions">
                                            <OpenLink to={`/admin/impostazioni/${g.id}`} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </section>
    );
}
